export default __webpack_public_path__ + "static/media/3.5be68227.jpg";